import { Injectable } from "@angular/core";
import { CircularInjectionHelper } from "../../services/circularInjectionHelper";
import { ObjectObserverFactory } from "../../services/objectObserverFactory";
import { IObjectObserver } from "../../services/IObjectObserver";
import { LocationDataModel, OrderDetailLocationViewModel, OrderHistoryDataModel, OrderHistoryDetailViewModel, paymentMethods } from "../../shared/models";
import { ContentType, ImageOrientation } from "../../shared/contentTypes";
import { Observable } from "rxjs";
import DateManager from "../../shared/dateManager";
import { CoreLogService } from "../../services/log.service";

export const paymentMethodsNames = {};
paymentMethodsNames[paymentMethods.AllUnknown] = "phPayment_MethodName_unknown";
paymentMethodsNames[paymentMethods.BarAbholungLieferung] = "phPayment_MethodName_Cash_DeliveryTakeAway";
paymentMethodsNames[paymentMethods.ec] = "phPayment_MethodName_ec";
paymentMethodsNames[paymentMethods.ecNational] = "phPayment_MethodName_EcNational";
paymentMethodsNames[paymentMethods.ecInternational] = "phPayment_MethodName_EcInternational";
paymentMethodsNames[paymentMethods.ecAusland] = "phPayment_MethodName_EcForeign";
paymentMethodsNames[paymentMethods.ecKundenkarte] = "phPayment_MethodName_ECustomerCard";
paymentMethodsNames[paymentMethods.VISA] = "phPayment_MethodName_visa";
paymentMethodsNames[paymentMethods.Mastercard] = "phPayment_MethodName_mc";
paymentMethodsNames[paymentMethods.Diners] = "phPayment_MethodName_diners";
paymentMethodsNames[paymentMethods.AMEX] = "phPayment_MethodName_amex";
paymentMethodsNames[paymentMethods.JCB] = "phPayment_MethodName_jcb";
paymentMethodsNames[paymentMethods.Breuninger] = "phPayment_MethodName_Breuninger";
paymentMethodsNames[paymentMethods.ecCash] = "phPayment_MethodName_ecCash";
paymentMethodsNames[paymentMethods.sonstigeKreditkarten] = "phPayment_MethodName_sonstigeKreditkarten";
paymentMethodsNames[paymentMethods.AdrevaMacao] = "phPayment_MethodName_AdrevaMacao";
paymentMethodsNames[paymentMethods.IKEAFamilyCard] = "phPayment_MethodName_IKEAFamilyCard";
paymentMethodsNames[paymentMethods.VisaDebit] = "phPayment_MethodName_VisaDebit";
paymentMethodsNames[paymentMethods.MCDebit] = "phPayment_MethodName_MCDebit";
paymentMethodsNames[paymentMethods.Maestro] = "phPayment_MethodName_Maestro";
paymentMethodsNames[paymentMethods.VPay] = "phPayment_MethodName_VPay";
paymentMethodsNames[paymentMethods.Postcard] = "phPayment_MethodName_Postcard";
paymentMethodsNames[paymentMethods.PayPalPicturePayment] = "phPayment_MethodName_PayPalPicturePayment";
paymentMethodsNames[paymentMethods.Einzahlung] = "phPayment_MethodName_Deposit";
paymentMethodsNames[paymentMethods.Auszahlung] = "phPayment_MethodName_Payout";
paymentMethodsNames[paymentMethods.TWINT] = "phPayment_MethodName_twint";
paymentMethodsNames[paymentMethods.WebInvoice] = "phPayment_MethodName_WebInvoice";
paymentMethodsNames[paymentMethods.ZahlungAnstehend] = "phPayment_MethodName_ZahlungAnstehend";
paymentMethodsNames[paymentMethods.CashController] = "phPayment_MethodName_CashController";
paymentMethodsNames[paymentMethods.PayPerApp] = "phPayment_MethodName_PayPerApp";
paymentMethodsNames[paymentMethods.Sofortüberweisung] = "phPayment_MethodName_directEbanking";
paymentMethodsNames[paymentMethods.BargeldlosBeiLieferung] = "phPayment_MethodName_Cashess_Delivery";
paymentMethodsNames[paymentMethods.PayDirect] = " phPayment_MethodName_PayDirect";
paymentMethodsNames[paymentMethods.PayPal] = "phPayment_MethodName_paypal";
paymentMethodsNames[paymentMethods.LunchCard] = "phPayment_MethodName_LunchCard";
paymentMethodsNames[paymentMethods.LunchCheckCard] = "phPayment_MethodName_LunchCheckCard";
paymentMethodsNames[paymentMethods.MaestroCH] = "phPayment_MethodName_MaestroCH";
paymentMethodsNames[paymentMethods.PowerCard] = "phPayment_MethodName_PowerCard";
paymentMethodsNames[paymentMethods.Loeb] = "phPayment_MethodName_Loeb";
paymentMethodsNames[paymentMethods.Manorcard] = "phPayment_MethodName_Manorcard";
paymentMethodsNames[paymentMethods.WIRcard] = "phPayment_MethodName_WIRcard";
paymentMethodsNames[paymentMethods.Reka] = "phPayment_MethodName_Reka";
paymentMethodsNames[paymentMethods.Giftcard] = "phPayment_MethodName_Giftcard";
paymentMethodsNames[paymentMethods.ChinaUnionPay] = "phPayment_MethodName_ChinaUnionPay";
paymentMethodsNames[paymentMethods.AliPay] = "phPayment_MethodName_Alipay";
paymentMethodsNames[paymentMethods.WeChat] = "phPayment_MethodName_WeChat";
paymentMethodsNames[paymentMethods.Sodexo] = "phPayment_MethodName_Sodexo";
paymentMethodsNames[paymentMethods.TWINTTerminal] = "phPayment_MethodName_TWINTTerminal";
paymentMethodsNames[paymentMethods.OnlineZahlung] = "phPayment_MethodName_OnlineZahlung";
paymentMethodsNames[paymentMethods.AmazonPay] = "phPayment_MethodName_AmazonPay";
paymentMethodsNames[paymentMethods.ApplePay] = "phPayment_MethodName_applepay";
paymentMethodsNames[paymentMethods.KlarnaPayNow] = "phPayment_MethodName_klarna_paynow";
paymentMethodsNames[paymentMethods.EPS_AT] = "phPayment_MethodName_EPS_AT";
paymentMethodsNames[paymentMethods.GooglePay] = "phPayment_MethodName_paywithgoogle";
paymentMethodsNames[paymentMethods.Paysafecard] = "phPayment_MethodName_Paysafecard";
paymentMethodsNames[paymentMethods.Wallet] = "phPayment_MethodName_Wallet";
paymentMethodsNames[paymentMethods.SEPA] = "phPayment_MethodName_Sepa";
paymentMethodsNames[paymentMethods.Discover] = "phPayment_MethodName_discover";
paymentMethodsNames[paymentMethods.girocard] = "phPayment_MethodName_Girocard";
paymentMethodsNames[paymentMethods.Webgutscheine] = "phPayment_MethodName_Voucher";
paymentMethodsNames[paymentMethods.MPA] = "phPayment_MethodName_MPA";
paymentMethodsNames[paymentMethods.BargeldlosAbholungLieferung] = "phPayment_MethodName_Cashless_DeliveryTakeaway";
paymentMethodsNames[paymentMethods.ZahlenAmPOS] = "phPayment_MethodName_PayAtPOS";


@Injectable()
export class OrderDetailService {

  /** OrderHistory Observer */
  private _orderHistoryObsServ: IObjectObserver<OrderHistoryDataModel>;
  private _locationObsServ: IObjectObserver<LocationDataModel>;
  constructor(private _circularInjectionHelper: CircularInjectionHelper
    , private _coreLogService: CoreLogService) {
    const me = this;
    me._orderHistoryObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<OrderHistoryDataModel>(ContentType.OrderHistory, me._circularInjectionHelper);
    me._locationObsServ = ObjectObserverFactory.GetObjectObserverByInjectionHelper<LocationDataModel>(ContentType.Location, me._circularInjectionHelper);
    // const placeholder = "phPayment_MethodName_" + paymentMethods[87]
  }

  /** Triggers if OrderHistory has changes (keys form changed orders) */
  public get OrderHistoryChanges(): Observable<(string | number)[]> {
    return this._orderHistoryObsServ.ObserveChanges;
  }

  /**
   * Getting the orderDetailDataModel by Id
   * @id id of Order
   * @result return a promise that resolves a  orderViewModel
   */
  public GetOrderDetailViewModel(id: number | string): Promise<OrderHistoryDetailViewModel> {
    const me = this;
    return new Promise<OrderHistoryDetailViewModel>((resolve, reject) => {
      me._orderHistoryObsServ.GetObject(id)
        .then((orderDetail) => {
          me.mapDataModelToDetailViewModel(orderDetail).then(resolve)
            .catch((e) => {
              me._coreLogService.error("OrderDetailService. _orderHistoryObsServ.GetObject", "mapDataModelToDetailViewModel", e);
              reject();
            });
        })
        .catch((e) => {
          me._coreLogService.error("OrderDetailService. _orderHistoryObsServ.GetObject", "_orderHistoryObsServ.GetObject", e);
          reject();
        });
    });
  }

  /**
    * map a OrderHistoryDataModel to EventViewModel
    * @param model Get a OrderHistoryDataModel for mapping
    * @result return a OrderHistoryDetailViewModel
    */
  private async mapDataModelToDetailViewModel(model: OrderHistoryDataModel): Promise<OrderHistoryDetailViewModel> {
    const me = this;
    if (model) {
      const viewModel = new OrderHistoryDetailViewModel();
      viewModel.id = model.id;
      viewModel.location = model.location;
      viewModel.loc_city = model.loc_city;
      viewModel.loc_label_de = model.loc_label_de;
      viewModel.loc_label_en = model.loc_label_en;
      viewModel.loc_street = model.loc_street;
      viewModel.loc_zip = model.loc_zip;
      viewModel.order_at = DateManager.MomentDateTimeFormatter(model.order_at, true, true);
      viewModel.order_type = model.order_type;
      viewModel.process_completed_pos_at_ymd = model.process_completed_pos_at_ymd;
      viewModel.payment_method = model.payment_method;
      viewModel.nocoo_code = model.nocoo_code;
      viewModel.nocoo_pin = model.nocoo_pin;
      viewModel.items = model.items;
      viewModel.groupName = model.group_name;
      //! Ist Erledigt
      // TODO: das folgende müsstest du noch so anpassen, wie du es brauchst
      // hierbei handelt es sich um eine map mit memberId as key und Mitgliedsnamen als value,
      // folgend ein Beispiel:
      // {
      //   1: "John Miller"
      // }
      // die items haben ggf. das feld cusRefId, welches auf den key in dieser map verweist
      //
      //!cusRefId returns null ,even if there are group members. So an item cannot be assigned to the user
      viewModel.group_member_names = model.group_member_names;
      viewModel.currency = model.currency;
      viewModel.delivery_fee = model.delivery_fee || 0;
      // TODO ohne UI für Versandkosten, werden sie als Lieferkosten angezeigt
      viewModel.delivery_fee += model.shipping || 0;
      viewModel.tip = model.tip;
      viewModel.payment_amount = model.payment_amount;
      return Promise.resolve(viewModel);
    } else {
      return Promise.resolve(null);
    }
  }

  public GetOrderLocationViewModel(id: number | string): Promise<OrderDetailLocationViewModel> {
    const me = this;
    return new Promise<OrderDetailLocationViewModel>((resolve, reject) => {
      // gets undeleted events
      me._locationObsServ.GetObject(id)
        .then((location) => {
          me.mapDataModelToLocationViewModel(location).then(resolve)
            .catch((e) => {
              me._coreLogService.error("OrderDetailService._locationObsServ.GetObject", "mapDataModelToLocationViewModel", e);
              reject();
            });
        })
        .catch((e) => {
          me._coreLogService.error("OrderDetailService._locationObsServ.GetObject", "_locationObsServ.GetObject", e);
          reject();
        });
    });
  }

  private async mapDataModelToLocationViewModel(model: LocationDataModel): Promise<OrderDetailLocationViewModel> {
    const me = this;
    if (model) {
      const viewModel = new OrderDetailLocationViewModel();
      viewModel.locationId = model.hyp_cus_nr;
      viewModel.location_image = ContentType.Location + "/" + viewModel.locationId + "_photo_" + ImageOrientation.Landscape + "/" + model.last_image_update_at_ymd + "/" + model.last_image_update_at_hms;
      return Promise.resolve(viewModel);
    }
  }


}